import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VaporDrawer from "../../../general/vapor/drawer";
import { Button } from "@ts-digital/vrc";
import { loadReconciliationMovements } from "../../../../store/actions/reconciliation/movements";
import { loadReconciliationAccounts } from "../../../../store/actions/reconciliation/accounts";
import {
  createReconciliationLink,
  removeReconciliationLink,
  getReconciledSummary
} from "../../../../store/actions/reconciliation/operations";
import BankContent from "./bank";
import ManualContent from "./manual";
import numeral from "numeral";
import DifferenceContent from "./difference";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imgError from "../../../../assets/img/deadlines-merge-feedback-ko.svg";
import ReconciliationForm from "./reconciliation";
import moment from "moment";
import { notification } from "antd";
import { openNotificationWithIcon } from "../../../../libs/utils";
import LoaderSimple from "../../../general/loader";
import { setDeadlineDetailPayment } from "../../../../store/actions/deadlines/detail";
import Collapsed from "../../../general/collapsed";
import { FormattedMessage } from "react-intl";
import womanImage from "../../../../assets/img/woman.svg";
import { FEATURE_TOGGLE_RECONCILIATION } from "../../../../config";
import {delay} from "../../../../libs/utils";

const DeadlinesRegisterDrawer = props => {
  const {
    visibleRegisterDrawer,
    onPaymentComplete,
    onClose,
    onCloseWithResidue,
    paymentType,
    isFiscalSocialSecurity,
    splitDeadlines,
    reconciliated,
    isStudio,
    isToPay
  } = props;
  
  const main = useSelector(state => state.main);
  const auth = useSelector(state => state.auth);

  const deadlinesDetail = useSelector(state => state.deadlinesDetail.subjective);

  const isPayingDeadline = useSelector(state => state.deadlinesDetail.isPayingDeadline);

  const deadlineAmount =
    deadlinesDetail.totalAmount < 0
      ? deadlinesDetail.totalAmount * -1
      : deadlinesDetail.totalAmount;

  const isSplitting = useSelector(state =>
    state.deadlinesDetail.splittedDeadlines.isSplitting &&
      !state.deadlinesDetail.splittedDeadlines.error);
  const tspay = useSelector(state => state.tspay);
  const servicesCompany = useSelector(state => state.servicesAgyo.allCompanyServices.status.list);
  const hasBankLinkPackage = servicesCompany.find(app => app.appId === "EBS"); // ha almeno informative o dispositive
  const isGettingReconciliationData = useSelector(state => state.reconciliation?.isGettingReconciliatonData);
  const reconciliation = useSelector(state => state.reconciliation);

  const [checkbox, setCheckbox] = useState(false);
  const [activeTab, setActiveTab] = useState(FEATURE_TOGGLE_RECONCILIATION !== "true"
    ? 2
    : reconciliated
      ? 3
      : hasBankLinkPackage
        ? 1
        : 2);
  const [showTabs, setShowTabs] = useState(false);
  const [step, setStep] = useState(1);
  const [valueRadio, setValueRadio] = useState("1");
  const [checkLowerAmount, setCheckLowerAmount] = useState(true);
  const [initialValue, setInitialValue] = useState(FEATURE_TOGGLE_RECONCILIATION !== "true" ? deadlineAmount : 0);
  const [editedValue, setEditedValue] = useState(0);
  const [paymentError, setPaymentError] = useState(false);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [collapsed, setCollapsed] = useState(true);
  const movementsReconciled = useSelector(state => state.reconciliation?.listData);
  const [selectedMovements, setSelectedMovements] = useState({});
  const [saveReconciliation, setSaveReconciliation] = useState(false);
  const [dateValue, setDateValue] = useState(FEATURE_TOGGLE_RECONCILIATION !== "true" ? new Date() : moment(new Date()));
  const [dateValueResidue, setDateValueResidue] = useState(moment(new Date()));
  const [startDate, setStartDate] = useState(moment()
    .subtract(2, "y")
    .format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment()
    .endOf("day")
    .format("YYYY-MM-DD"));

  const [paymentValueResidue, setPaymentValueResidue] = useState(paymentType && paymentType.mode.id
    ? paymentType.mode.id
    : paymentType.execution && paymentType.execution.id
      ? paymentType.id
      : deadlinesDetail.scope === "fiscal_social_security"
        ? "PM01"
        : "PM05");
  const [paymentValue, setPaymentValue] = useState(paymentType && paymentType.mode.id
    ? paymentType.mode.id
    : paymentType.execution && paymentType.execution.id
      ? paymentType.id
      : deadlinesDetail.scope === "fiscal_social_security"
        ? "PM01"
        : "PM05");
  const [, setConfigStatus] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (visibleRegisterDrawer && FEATURE_TOGGLE_RECONCILIATION === "true") {
      dispatch(loadReconciliationAccounts(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected
      )).then(res => {
        let accountsFound = res.data.bankAccounts;
        if (accountsFound.length > 0) {
          dispatch(loadReconciliationMovements(
            auth,
            main.accountantUuidSelected,
            main.companyUuidSelected,
            accountsFound[0].accountId,
            startDate,
            endDate,
            isToPay ? "toPay" : "toCollect"
          ));
          setSelectedBankAccount(accountsFound[0].accountId);
        }
      });
    }
  }, [visibleRegisterDrawer]);

  useEffect(() => {
    setEditedValue(FEATURE_TOGGLE_RECONCILIATION !== "true"
      ? deadlineAmount
      : deadlinesDetail.totalAmount);
  },[FEATURE_TOGGLE_RECONCILIATION, deadlineAmount]);

  useEffect(() => {
    dispatch(loadReconciliationMovements(
      auth,
      main.accountantUuidSelected,
      main.companyUuidSelected,
      selectedBankAccount,
      startDate,
      endDate,
      isToPay ? "toPay" : "toCollect"
    ));
  }, [startDate, endDate]);

  useEffect(() => {
    checkEditedValue();
  }, [editedValue]);

  useEffect(() => {
    const amount =
      deadlinesDetail.totalAmount < 0
        ? deadlinesDetail.totalAmount * -1
        : deadlinesDetail.totalAmount;
    setEditedValue(amount);
    setInitialValue(amount);
  }, [deadlinesDetail]);

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, [tspay]);

  useEffect(() => {
    if (FEATURE_TOGGLE_RECONCILIATION === "true") {
      let total = 0;
      if (
        selectedMovements &&
        !isGettingReconciliationData &&
        !reconciliation.movements.status.started &&
        activeTab !== 2

      ) {
        Object.keys(selectedMovements).forEach(valueKey => {
          total += selectedMovements[valueKey].amount;
        });
        setSelectedAmount(total);
        setEditedValue(total);
      }
    }
  }, [selectedMovements]);

  useEffect(() => {
    let totalAmount = 0;
    if (
      reconciliated &&
      activeTab === 3 &&
      !isGettingReconciliationData &&
      !reconciliation.movements.status.started
    ) {
      movementsReconciled.map(item => {
        const transaction = item.transaction;
        totalAmount += transaction.amount;
        return totalAmount;
      });
    }
    setSelectedAmount(totalAmount);
  }, [isGettingReconciliationData, reconciliation.movements.status]);

  useEffect(() => {
    let selectedMovementsDict = {};
    if (reconciliated && activeTab === 3) {
      movementsReconciled.map(item => {
        // Il formato dei movimenti riconciliati è un po' diverso da quello accettato dalla maschera con la lista movimenti
        // transactionDate: '2021-09-06', amount: -45, description: 'pagamento biglietto ingresso conferenza', companyName: 'test-company-1'
        selectedMovementsDict[item.bankTransactionId] = {
          id: item.bankTransactionId,
          amount: item.transaction.amount,
          description: item.transaction.description,
          transactionDate: item.transaction.transactionDate,
          status: item.status
        };
        return null;
      });
    }
    setSelectedMovements(selectedMovementsDict);
  }, [isGettingReconciliationData, reconciliation.movements.status]);

  useEffect(() => {
    if (reconciliation.movements.list.length === 0) {
      setSelectedBankAccount(null);
    }
  }, [reconciliation.movements.list]);

  const checkEditedValue = props => {
    const amountToCheck =
      deadlinesDetail.totalAmount < 0
        ? deadlinesDetail.totalAmount * -1
        : deadlinesDetail.totalAmount;
    const editedValueAbs = editedValue < 0 ? editedValue * -1 : editedValue;
    if (editedValueAbs < amountToCheck) {
      setCheckLowerAmount(true);
    } else {
      setCheckLowerAmount(false);
    }
  };

  const setMovement = movement => {
    let idMov = movement.bankTransactionId
      ? movement.bankTransactionId
      : movement.id;
    let mov = movement.transaction ? movement.transaction : movement;
    let deadlineId = deadlinesDetail.id;
    if (!selectedMovements[idMov]) {
      setSelectedMovements({ ...selectedMovements, [idMov]: mov });
    } else {
      let tmpSelectedMovements = { ...selectedMovements };
      delete tmpSelectedMovements[idMov];
      dispatch(removeReconciliationLink(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected,
        [{ deadlineId, bankTransactionId: idMov }],
        "DEADLINE"
      )).then(res =>
        delay(3000).then(() => dispatch(getReconciledSummary())));
      setSelectedMovements(tmpSelectedMovements);
    }
  };

  const renderMovements = () => {
    let items = [];
    if (movementsReconciled) {
      movementsReconciled.map(item => {
        let sentToAccounting = item.status === "SENT_TO_ACCOUNTING";
        const transaction = item.transaction;
        return items.push(<div
          className={
            "dbx-drawer-reconciliation-movement" +
              (selectedMovements[item.bankTransactionId]
                ? " movementSelected"
                : "")
          }
        >
          <div className="dbx-drawer-reconciliation-movement-info">
            <span>
              {moment(transaction.transactionDate).format("DD MMM YYYY")}
            </span>
            <span>
              {transaction.amount < 0 ? "-" : "+"}{" "}
              {numeral(Math.abs(transaction.amount)).format("0,0.00")} €
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignContent: "center",
                width: "85%"
              }}
            >
              <div className="dbx-drawer-reconciliation-movement-description">
                {transaction.description}
              </div>
            </div>
            <div
              style={{ cursor: sentToAccounting ? null : "pointer" }}
              className="dbx-drawer-reconciliation-movement-icon"
              onClick={() => (sentToAccounting ? {} : setMovement(item))}
            >
              <FontAwesomeIcon
                icon={[
                  "far",
                  sentToAccounting
                    ? "lock"
                    : selectedMovements[item.bankTransactionId]
                      ? "times"
                      : "link"
                ]}
              />
            </div>
          </div>
        </div>);
      });
    }
    return items;
  };

  const renderReconciliatedMovements = () => {
    let items = [];
    Object.keys(selectedMovements).map(i => {
      let selMov = selectedMovements[i];
      let sentToAccounting = selMov.status === "SENT_TO_ACCOUNTING";
      selMov.id = i;
      return items.push(<div className="dbx-drawer-selected-movement">
        <div className="dbx-drawer-selected-movement-info">
          <span>
              Data pagamento:{" "}
            <strong>
              {moment(selMov.transactionDate).format("DD MMM YYYY")}
            </strong>
          </span>
          <span>
              Importo pagato:{" "}
            <strong>
              {numeral(Math.abs(selMov.amount)).format("0,0.00")} €
            </strong>
          </span>
        </div>
        <div
          className="dbx-drawer-selected-movement-remove"
          style={{ cursor: sentToAccounting ? null : "pointer" }}
          onClick={() => (sentToAccounting ? {} : setMovement(selMov))}
        >
          <FontAwesomeIcon
            icon={["far", sentToAccounting ? "lock" : "times"]}
          />
        </div>
      </div>);
    });
    return items;
  };

  const registerPayment = doReconciliation => {
    if (doReconciliation) {
      let linkList = [];
      let deadlineId = deadlinesDetail.id;
      let movementsIdList = Object.keys(selectedMovements);
      movementsIdList.forEach(bankTransactionId =>
        linkList.push({ deadlineId, bankTransactionId }));
      // Procedura di pagamento con riconciliazione bancaria
      dispatch(createReconciliationLink(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected,
        linkList,
        "DEADLINE"
      )).then(() => {
        onPaymentComplete();
        delay(3000).then(() => dispatch(getReconciledSummary()));
      });
    } else {
      // Procedura di pagamento semplice
      dispatch(setDeadlineDetailPayment(
        deadlinesDetail.id,
        "paid",
        paymentValue,
        dateValue
      ))
        .then(() => {
          openNotificationWithIcon(
            notification,
            "success",
            "",
            "Pagamento registrato con successo",
            null,
            null
          );
          onPaymentComplete();
        })
        .catch(() => {
          setPaymentError(true);
        });
    }
  };

  const onReturnClick = () => {
    setStep(1);
  };

  const renderAlert = () => {
    return (
      <div style={{ textAlign: "center", marginTop: "60px" }}>
        <div>
          <img
            style={{ width: "159px", height: "158px" }}
            src={womanImage}
            alt=""
          />
        </div>
        <div className="reconciliationAlert">
          <FormattedMessage id="deadlines.reconciliation.reconciliationAlert"></FormattedMessage>
        </div>
      </div>
    );
  };

  const onConfirmClick = () => {
    // REGISTRAZIONE BANCARIA
    if (activeTab === 1) {
      if (
        activeTab === 1 &&
        step === 1 &&
        Math.abs(parseFloat(editedValue)) -
          Math.abs(parseFloat(deadlinesDetail.totalAmount)) ===
          0
      ) {
        registerPayment(true);
      } else {
        if (step === 1 && checkLowerAmount) {
          setActiveTab(2);
          setStep(2);
          // Vado allo step due proveniendo dalla registrazione bancaria quindi dovrò riconciliare la scadenza che viene pagata/incassata
          setSaveReconciliation(true);
        } else if (step === 1 && !checkLowerAmount) {
          // TODO
          return;
        }
      }
    } else {
      // REGISTRAZIONE MANUALE
      // step 1 con importo inserito uguale a importo totale scadenza
      if (
        step === 1 &&
        Math.abs(parseFloat(editedValue)) -
          Math.abs(parseFloat(deadlinesDetail.totalAmount)) ===
          0
      ) {
        registerPayment();
        return;
      } 
      // step 1 (se valore più basso passo a step 2 (vado al pagamento parziale))
      if (step === 1 && checkLowerAmount) {
        setStep(2);
      } else {
        // step 1 (se valore inserito più alto dell'importo scadenza, lo rimetto all'originale)
        if (editedValue > initialValue) {
          setEditedValue(initialValue);
          return;
        }
        // step 2 (PAGAMENTO PARZIALE)
        if (step === 2 && valueRadio === "1") {
          // caso di creazione nuova scadenza con importo residuo
          const newList = [];
          newList.push({
            date: deadlinesDetail.date,
            amount:
                  deadlinesDetail.payment.type === "item_pays"
                    ? -Math.abs(editedValue)
                    : editedValue,
            paymentModeId: paymentValue,
            execution: {
              mode: paymentValue,
              date:
                    typeof dateValue === "string"
                      ? moment(dateValue, "DD-MM-YYYY")
                      : dateValue
            },
            paymentStatus: "paid"
          },
          {
            date: dateValueResidue,
            amount:
                  deadlinesDetail.payment.type === "item_pays"
                    ? Number(deadlinesDetail.totalAmount) +
                      Math.abs(Number(editedValue))
                    : Number(deadlinesDetail.totalAmount) - Number(editedValue),
            paymentModeId: paymentValueResidue,
            paymentStatus: checkbox ? "suspended" : "due"
          });
          dispatch(splitDeadlines(
            deadlinesDetail.id,
            newList,
            true
          )).then(res =>
            onCloseWithResidue(
              res, saveReconciliation, selectedMovements
            ));
        } else {
          // ABBUONA
          let newListAbbuona = [];
          newListAbbuona.push({
            date:
                  typeof deadlinesDetail.date === "string"
                    ? new Date(deadlinesDetail.date)
                    : deadlinesDetail.date,
            amount:
                  deadlinesDetail.payment.type === "item_pays"
                    ? -Math.abs(editedValue)
                    : editedValue,
            paymentModeId: paymentValue,
            execution: {
              mode: paymentValue,
              date:
                    typeof dateValue === "string"
                      ? moment(dateValue, "DD-MM-YYYY")
                      : dateValue
            },
            paymentStatus: "paid"
          },
          {
            date:
                  typeof dateValueResidue === "string"
                    ? new Date(dateValueResidue)
                    : dateValueResidue,
            amount:
                  deadlinesDetail.payment.type === "item_pays"
                    ? Number(deadlinesDetail.totalAmount) +
                      Math.abs(Number(editedValue))
                    : Number(deadlinesDetail.totalAmount) - Number(editedValue),
            paymentModeId: paymentValue,
            execution: {
              mode: paymentValue,
              date:
                    typeof dateValue === "string"
                      ? moment(dateValue, "DD-MM-YYYY")
                      : dateValue
            },
            rebated: true,
            paymentStatus: "paid"
          });
          dispatch(splitDeadlines(
            deadlinesDetail.id,
            newListAbbuona,
            true
          )).then(res =>
            onCloseWithResidue(
              res, saveReconciliation, selectedMovements
            ));
        }
      }
      
    }
  };

  const residueAmount =
    deadlinesDetail.payment.type === "item_pays"
      ? Math.abs(Number(deadlinesDetail.totalAmount) + Math.abs(Number(editedValue)))
        .toFixed(2)
        .replace(".", ",")
      : Math.abs(Number(deadlinesDetail.totalAmount) - Math.abs(Number(editedValue)))
        .toFixed(2)
        .replace(".", ",");

  return (
    <VaporDrawer
      customClassName="dbx-deadlines-register-drawer"
      title={
        "REGISTRA " +
        (deadlinesDetail.totalAmount < 0 ? "PAGAMENTO" : "INCASSO")
      }
      mask={false}
      subtitle={""}
      visible={visibleRegisterDrawer}
      onClose={onClose}
      width={800}
      buttons={
        activeTab === 3
          ? null
          : !isPayingDeadline && !paymentError
            ? [
              <Button  key={`clear_${paymentError}`} onClick={onClose} kind="secondary">
                Annulla
              </Button>,
              <Button
                key={`disabled_${selectedMovements}`}
                disabled={
                  activeTab === 1 && Object.keys(selectedMovements).length === 0
                }
                kind="primary"
                onClick={() => onConfirmClick()}
              >
                {activeTab === 1 && step === 1 && "Associa"}
                {activeTab === 2 && step === 1 && "Registra"}
                {step === 2 && "Salva"}
              </Button>
            ]
            : paymentError
              ? [
                <Button  key={`paymentError_${paymentError}`} onClick={onClose} kind="secondary">
                Chiudi
                </Button>
              ]
              : null
      }
      leftButtons={
        !isPayingDeadline && !paymentError && step === 2 && checkLowerAmount
          ? [
            <Button key={`checkLowerAmount_${checkLowerAmount}`} kind="tertiary" onClick={() => onReturnClick()}>
              <FontAwesomeIcon
                icon={("far", "arrow-left")}
                style={{ marginRight: 10 }}
              />{" "}
                Torna indietro
            </Button>
          ]
          : null
      }
      maskClosable={false}
    >
      {" "}
      {!isSplitting ? (
        <div className="dbx-register-drawer-root">
          {/* Nel caso di scadenza riconciliata non devo vedere i tab per registrazione bancaria e manuale */}
          {reconciliated && !showTabs ? (
            <div className="dbx-register-drawer-dates">
              <Collapsed           
                key={"history"}     
                isCollapsed={collapsed}
                onClick={e => {
                  setCollapsed(!collapsed);
                }}
                title={
                  <span>
                    <span style={{ marginRight: "290px" }}>
                      {"Movimenti bancari selezionati"}
                    </span>
                    <span style={{ color: "#152935" }}>
                      Totale:{" "}
                      <b>
                        {!isGettingReconciliationData &&
                        !reconciliation.movements.status.started ? (
                            numeral(Math.abs(selectedAmount)).format("0,0.00")
                          ) : (
                            <FontAwesomeIcon
                              className="deadlines-header-tspay-spinner"
                              icon={["far", "spinner"]}
                              spin
                            />
                          )}{" "}
                        €{" "}
                      </b>
                    </span>
                  </span>
                }
              >
                {renderReconciliatedMovements()}
              </Collapsed>
              {Object.keys(selectedMovements).length !== 0
                ? renderMovements()
                : renderAlert()}
              <div
                className="dbx-register-drawer-other-movements"
                onClick={() => {
                  setShowTabs(true);
                  setActiveTab(1);
                }}
              >
                {"Guarda altri movimenti da associare"}
              </div>
            </div>
          ) : (
            !paymentError &&
            !isPayingDeadline &&
            step === 1 && (
              <div className="dbx-register-drawer-tabs">
                {FEATURE_TOGGLE_RECONCILIATION === "true" && (
                  <div
                    onClick={() => setActiveTab(1)}
                    className={
                      "dbx-register-drawer-tab" +
                      (activeTab === 1 ? " active" : "")
                    }
                    style={{ display: !hasBankLinkPackage }}
                  >
                    Registrazione bancaria
                  </div>
                )}
                {!isStudio ? (
                  <div
                    onClick={() => {
                      const amount =
                        deadlinesDetail.totalAmount < 0
                          ? deadlinesDetail.totalAmount * -1
                          : deadlinesDetail.totalAmount;
                      setEditedValue(amount);
                      setInitialValue(amount);
                      setActiveTab(2);
                      setDateValue(new Date());
                      checkEditedValue();
                    }}
                    id="dbx-register-drawer-tab-manual"
                    className={
                      "dbx-register-drawer-tab" +
                      (activeTab === 2 ? " active" : "")
                    }
                  >
                    Registrazione manuale
                  </div>
                ) : null}
              </div>
            )
          )}
          {!paymentError && !isPayingDeadline && step === 2 && (
            <ReconciliationForm
              amountToPay={editedValue}
              paymentValue={paymentValue}
              deadlinesDetail={deadlinesDetail}
              totalAmount={deadlinesDetail.totalAmount}
              residueAmount={residueAmount}
              deadlineDate={deadlinesDetail.date}
              deadlineDescription={
                deadlinesDetail.description.title +
                "" +
                (deadlinesDetail.description.details
                  ? deadlinesDetail.description.details
                  : "")
              }
              setPaymentValueResidue={setPaymentValueResidue}
              paymentValueResidue={paymentValueResidue}
              setCheckbox={setCheckbox}
              checkbox={checkbox}
              setDateValueResidue={setDateValueResidue}
              dateValueResidue={dateValueResidue}
              setValueRadio={setValueRadio}
              valueRadio={valueRadio}
              isMultipleReconciliation={false}
              setInvalidSelectionBiggerDeadlines={() => {}}
            ></ReconciliationForm>
          )}
          <div className="dbx-register-drawer-body">
            {!paymentError &&
              !isPayingDeadline &&
              step === 1 &&
              activeTab === 1 && (
              <BankContent
                setSelectedAmount={setSelectedAmount}
                selectedAmount={selectedAmount}
                selectedMovements={selectedMovements}
                setSelectedMovements={setSelectedMovements}
                checkLowerAmount={checkLowerAmount}
                setCheckLowerAmount={setCheckLowerAmount}
                setSelectedBankAccount={setSelectedBankAccount}
                selectedBankAccount={selectedBankAccount}
                setEditedValue={setEditedValue}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                startDate={startDate}
                endDate={endDate}
              />
            )}
            {!paymentError &&
              !isPayingDeadline &&
              step === 1 &&
              activeTab === 2 && (
              <ManualContent
                setCheckLowerAmount={setCheckLowerAmount}
                deadlinesDetail={deadlinesDetail}
                dateValue={dateValue}
                setDateValue={setDateValue}
                paymentValue={paymentValue}
                setPaymentValue={setPaymentValue}
                initialValue={initialValue}
                setInitialValue={setInitialValue}
                editedValue={editedValue}
                setEditedValue={setEditedValue}
                isFiscalSocialSecurity={isFiscalSocialSecurity}
                isDrawer={true}
              />
            )}
            {!paymentError &&
              !isPayingDeadline &&
              step === 2 &&
              checkLowerAmount && (
              <DifferenceContent
                checkLowerAmount={checkLowerAmount}
                setCheckLowerAmount={setCheckLowerAmount}
              />
            )}
            {isPayingDeadline && (
              <LoaderSimple
                message={`Registrazione ${
                  deadlinesDetail.totalAmount < 0 ? "pagamento" : "incasso"
                } scadenza`}
              />
            )}
            {paymentError && (
              <div className="dbx-register-drawer-error">
                <div>
                  <img src={imgError} alt="" />
                </div>
                <div>
                  Errore durante la registrazione del{" "}
                  {deadlinesDetail.totalAmount < 0 ? "pagamento" : "incasso"}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="dbx-register-drawer-splitting-loading-container">
          <LoaderSimple
            message={
              <FormattedMessage id="deadlines.pages.detail.registerIsSplitting" />
            }
          />
        </div>
      )}
    </VaporDrawer>
  );
};

export default DeadlinesRegisterDrawer;
